import verConfig, { ver as _ver_ } from "@tt/config";
export const ver = _ver_;
// export const ver = 'A6405';

export const verData = {
  "A6107": {
    tabbar: {
      background: "#fff",
      selectedColor: "#1989fa",
      color: "#323233",
      type: "image",
      pages: [
        {
          text: 'newTab.home',
          pagePath: 'goods',
          component: () => import("@/view/goods"),
          iconPath: require("@/assets/tabbar/home.png"),
          selectedIconPath: require("@/assets/tabbar/home_active.png"),
          isSpecial: false,
        },
        {
          text: '代理',
          pagePath: 'agent',
          component: () => import('@/view/agent'),
          iconPath: require("@/assets/tabbar/agent.png"),
          selectedIconPath: require("@/assets/tabbar/agent_active.png"),
          isSpecial: false,
        },
        {
          text: 'AI下注',
          pagePath: 'ai',
          component: () => import('@/view/ai'),
          iconPath: require("@/assets/tabbar/ai.png"),
          selectedIconPath: require("@/assets/tabbar/ai_active.png"),
        },
        {
          text: `订金`,
          pagePath: 'new-recharge',
          component: () => import('@/view/bank/recharge'),
          iconPath: require("@/assets/tabbar/deposit.png"),
          selectedIconPath: require("@/assets/tabbar/deposit_active.png"),
          isSpecial: false,
        },
        {
          text: '我的',
          pagePath: 'user',
          component: () => import('@/view/user'),
          iconPath: require("@/assets/tabbar/mine.png"),
          selectedIconPath: require("@/assets/tabbar/mine_active.png"),
          isSpecial: false,
        },
      ]
    }
  },
}

export default {
  ...verConfig, ...verData[ver]
};